export const DEFAULT_UI_STATE = {
  showInclined: true,
  showCoplanar: false,
  showGimbal: false,
  theta: 0,
  showAllFootprints: false,
  showVolume: true,
  showXraySurface: false,
};

export const DEFAULT_PARAMS = {
  sod: 2.0,
  sdd: 490.0,
  tiltX: 51.0,
  tiltY: 0.0,
  detWidth: 2803,
  detHeight: 2401,
  detPitch: 0.1,
  offsetU: 0.0,
  offsetV: 0.0,
  numAngles: 100,
  angleStart: 0,
  angleEnd: 360,
  volRes: 0.00041,
  volX: 500,
  volY: 500,
  volZ: 500,
  offsetVolX: 0.0,
  offsetVolY: 0.0,
  offsetVolZ: 0.0,
};

export const PARAM_RANGES = {
  sod: { min: 0.5, max: 50, step: 0.1, label: "SOD", unit: "mm" },
  sdd: { min: 50, max: 1500, step: 1, label: "SDD", unit: "mm" },
  tiltX: { min: -89, max: 89, step: 0.5, label: "Tilt X", unit: "deg" },
  tiltY: { min: -89, max: 89, step: 0.5, label: "Tilt Y", unit: "deg" },
  detWidth: { min: 100, max: 4000, step: 1, label: "Detector Width", unit: "px" },
  detHeight: { min: 100, max: 4000, step: 1, label: "Detector Height", unit: "px" },
  detPitch: { min: 0.05, max: 1.0, step: 0.01, label: "Detector Pitch", unit: "mm/px" },
  offsetU: { min: -200, max: 200, step: 1, label: "Offset U", unit: "px" },
  offsetV: { min: -200, max: 200, step: 1, label: "Offset V", unit: "px" },
  numAngles: { min: 1, max: 2000, step: 1, label: "Number of projections", unit: "" },
  angleStart: { min: -360, max: 360, step: 1, label: "Start", unit: "deg" },
  angleEnd: { min: -360, max: 360, step: 1, label: "End", unit: "deg" },
  volRes: { min: 0.000001, max: 1, step: 0.001, label: "Resolution", unit: "mm/px" },
  volX: { min: 1, max: 5000, step: 1, label: "X", unit: "px" },
  volY: { min: 1, max: 5000, step: 1, label: "Y", unit: "px" },
  volZ: { min: 1, max: 5000, step: 1, label: "Z", unit: "px" },
  offsetVolX: { min: -5, max: 5, step: 0.1, label: "X", unit: "mm" },
  offsetVolY: { min: -5, max: 5, step: 0.1, label: "Y", unit: "mm" },
  offsetVolZ: { min: -5, max: 5, step: 0.1, label: "Z", unit: "mm" },
};

/** numAngles frames spaced evenly across [start, end] inclusive of both ends. */
export function buildAngles(numAngles, start = 0, end = 360) {
  const angles = new Array(numAngles);
  if (numAngles === 1) {
    angles[0] = start;
    return angles;
  }
  const span = end - start;
  for (let i = 0; i < numAngles; i++) angles[i] = start + (span * i) / (numAngles - 1);
  return angles;
}
